/* eslint-disable react/prop-types */
import '../index.scss';

import * as React from 'react';
import {Context_role} from '../../../../context/rolesStore';
import {Context} from '../../../../context/dataStore';
import { CBAccordion, CBUtils} from '../../../../constants/apricotCBform';
import removeSpaces from '../../../../constants/removeSpace';
import {Pagination, Checkbox} from '../../../../components';
import TotalUtils from '../../../../utils/TotalUtil';

const ActiveAccordion = ({middlearray, setMiddleArray, selectarray, setSelectedArray, updateAllToListFlag, data }) => {

  const {state: {newroles} } = React.useContext(Context_role);
  const {dispatch} = React.useContext(Context);

  //pagenation related states
  const [currentPage, setCurrentPage] = React.useState(1);
  const [recordPerPage, setRecordPerPage] = React.useState(10);
  const lastPage = Math.ceil(data?.length / recordPerPage);
  const displaySurvey = data?.slice((currentPage - 1) * recordPerPage, currentPage * recordPerPage);

  const Utils = new TotalUtils();

  React.useLayoutEffect(() => {
    CBAccordion({ elem: document.querySelector('.cb-accordion'),
    callBack: setCheckbox });
  }, []);

  React.useEffect(()=> {
    const middleTemp = [];
    let isCurrent = true;
    if(isCurrent&&data.length>0){
      data.forEach(elem => {
        elem.majors.forEach(major => {
          major.boxChecked = null;
          major.degrees = [null, null, null, null, null, null, null, null, null];
          middleTemp.push(major);
          major.new = true;
          major.modified = false;
        });
      });
      setMiddleArray([...(new TotalUtils()).elegantRemoveDuplicate(middleTemp)]);
    }
    return() => isCurrent = false;
  }, [data, setMiddleArray]);

  const setCheckbox = (panel) => {
    if(CBUtils.hasClass(panel, "cb-in")){
      const checkboxes= document.querySelectorAll(`div#${panel.id} input[type=checkbox]`);
      checkboxes.forEach(e =>{e.setAttribute("tabindex", "0"); e.setAttribute('aria-hidden', false);});
    }
    else{
      const checkboxes= document.querySelectorAll(`div#${panel.id} input[type=checkbox]`);
      checkboxes.forEach(e => {e.setAttribute("tabindex", "-1"), e.setAttribute('aria-hidden', true);});
    }
  };
  const handleOnChange = el => {
    switch (el) {
      case 'pre': {
        const newpage = currentPage === 1 ? currentPage : currentPage - 1;
        setCurrentPage(() => newpage);
        document.getElementById('majorSearchInput').setAttribute('aria-describedby', `searchMajor-page-${newpage}`);
        break;
      }
      case 'next': {
        const newpage = currentPage === lastPage ? currentPage : currentPage + 1;
        setCurrentPage(() => newpage);
        document.getElementById('majorSearchInput').setAttribute('aria-describedby', `searchMajor-page-${newpage}`);
        break;
      }
      default: {
        setCurrentPage(() => el);
        document.getElementById('majorSearchInput').setAttribute('aria-describedby', `searchMajor-page-${el}`);
      }
    }
  };

  return (
    <div>
      <div id='bfcp_accordion' className='cb-accordion' data-cb-apricot='accordion'>
        <div className='cb-accordion-panels'>
          {
            displaySurvey?.map((elem, index) => {
              return (
                <div key={index} id={`${removeSpaces(elem.dheader)}_${index}majorkey`} className='cb-accordion-container'>
                  <a href='#' className='cb-accordion-heading' id={`${removeSpaces(elem.dheader)}_${index}majorheader`}>
                    <div className='cb-accordion-heading-title'>
                      <span> {elem.dheader} </span>
                      <div className='cb-accordion-icon'>
                        <span className='line top' />
                        <span className='line bottom' />
                      </div>
                    </div>
                  </a>
                  <div className={`cb-accordion-panel cb-white-gradient-top transition ${index===0?"cb-in":""}`} role='region' style={{height: 'inherit !important'}}>
                    <div className='cb-accordion-panel-content'>
                      <ol id={`accordion_ol_${removeSpaces(elem.dheader)}_${index}_list`} className='accordion_ol_list'>
                        <li key={index}
                          id={`${removeSpaces(elem.dheader)}_`+`${Math.random()+index}`.split('.')[1]+'chbox'}>
                            <Checkbox isDisabled={false} halfInput={true} checkboxInput={!!Utils.headerBoolFlag(elem.majors, selectarray)} checkboxId={`${removeSpaces(elem.dheader)}_${index}checkbox`} checkboxName={elem.dheader} checkboxClass='addalltolistHeader'
                            checkboxValue='Add all to List' onChangecheckboxValue={e => {
                                Utils.onChangeHeaderBool(elem.majors, selectarray, e.target.checked, setSelectedArray);

                                //reset selected search box value to be empty  
                                dispatch({type:'SEL_SEARCH_VAL',payload:''});

                                if(e.target.checked === true) {
                                  dispatch({type: 'SELECT_ALL_COLUMNS', payload: [false, false, false, false, false, false, false, false, false]});
                                }
                                updateAllToListFlag(false);
  
                            }}
                            org_rol={newroles[0]} statusOfModule={false} />
                        </li>
                        {
                          elem.majors.map((maj, index2) => {
                            return(
                              <li key={index2} 
                              id={maj.qid} style={{ height: 'max-content !important' }}>
                                <Checkbox isDisabled={false} halfInput={true} checkboxInput={!!Utils.majorInput(selectarray, maj.qid)} checkboxId={`${maj.qid}chkboxmaj`} checkboxClass='addalltolist' checkboxName={maj.name} checkboxValue={maj.name} onChangecheckboxValue={e => {
                                 Utils.updateMajorInput(selectarray, middlearray, e.target.checked, maj.qid, setSelectedArray);

                                  dispatch({type:'SEL_SEARCH_VAL',payload:''});
                                  updateAllToListFlag(false);
                                  //let checkFlag=true;
                                  if(e.target.checked===true){
                                    dispatch({type: 'SELECT_ALL_COLUMNS', payload: [false, false, false, false, false, false, false, false, false]});
                                  }
                                  
                                }}
                                org_rol={newroles[0]} statusOfModule={false} />
                              </li>
                            );
                          })
                        }
                      </ol>
                    </div>
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>
      <div style={{ display: `${data.length === 0 ? 'none' : 'flex'}`, width: '81vw', textAlign: 'center', margin: '5% 0px' }}>
        <Pagination currentPage={currentPage} lastPage={lastPage} onPageChange={handleOnChange} id='searchMajor' />
      </div>
    </div>
  );
};

export default ActiveAccordion;